import { Component, OnInit } from '@angular/core';
import { QuotationDetailsComponent } from '../../../page-quotation/quotation-details.component';

@Component({
    selector: 'app-page-quotation-details',
    templateUrl: './page-quotation-details.component.html',
    styleUrls: ['./page-quotation-details.component.scss'],
    standalone: true,
    imports: [QuotationDetailsComponent]
})
export class PageQuotationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
